<template src="../templates/normal_fcont_160.html" />
<script>
import LabelFunMessage from '../components/LabelFunMessage'

import FuncSearchGalleryQR from '../components/FuncSearchGalleryQR'
import FuncSearchRecommendLink from '../components/FuncSearchRecommendLink'
import UseDesignPaperList from '../components/UseDesignPaperList'
import PrintButton from '../components/PrintButton'
import CreatorProfileShihoMasuda from '../components/CreatorProfileShihoMasuda'
import InfoMachineTranslation from '../components/InfoMachineTranslation'
import { Carousel,Slide } from 'uiv'

export default {
  name: 'app',
  data() {
    return {
      articleId: '160',
      app_root: process.env.VUE_APP_ROOT
    };
  },
  components: {
    LabelFunMessage, Carousel,Slide,FuncSearchRecommendLink,
    FuncSearchGalleryQR,
    UseDesignPaperList,PrintButton,CreatorProfileShihoMasuda,InfoMachineTranslation
  },
  computed: {
  },
  metaInfo() {
    return {
      title: this.$store.state.messages.messages['160-1'],
      meta: [
        { name: 'description', content: this.$store.state.messages.messages['160-3']}
      ]
    };
  }
  
};
</script>
<style scoped>
</style>

